exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._2wLJ7_ISgjRTktd9UiMpP0{margin-bottom:20px;height:30px;border-radius:4px;border:3px dashed #1c79ff;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:7px}", "", {"version":3,"sources":["/home/runner/work/frontend/frontend/src/App/components/DashedLabel/styles.css"],"names":[],"mappings":"AAAA,yBACE,mBAAoB,AACpB,YAAa,AACb,kBAAmB,AACnB,0BAA2B,AAC3B,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AACxB,WAAa,CACd","file":"styles.css","sourcesContent":[":local(.container) {\n  margin-bottom: 20px;\n  height: 30px;\n  border-radius: 4px;\n  border: 3px #1c79ff dashed;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 7px;\n}\n\n/* font-size: 15px;\n    font-weight: bold;\n    color: #1d79ff;\n    font-family: monospace;\n} */\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "_2wLJ7_ISgjRTktd9UiMpP0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/App/components/DashedLabel/styles.css
// module id = 4167
// module chunks = 22